import React from "react";
import CardVideo from "./CardVideo";
import "./_template-video.scss";

const url = {
  url1: "https://www.youtube.com/embed/PdesT08nbVk?rel=0&amp;controls=0",
  url2: "https://www.youtube.com/embed/g5JMQ4xEKHI?rel=0&amp;controls=0",
  url3: "https://www.youtube.com/embed/GZFjn62-3gg?rel=0&amp;controls=0",
};
const title = {
  title1: "Elegant 05",
  title2: "Rustic 02",
  title3: "Minimalist 01",
};

function TemplateVideo() {
  return (
    <section id="template-video" className="pt-10">
      <div className="container">
        <div className="row justify-content-center">
          <div
            className="col-12 col-lg-7"
            data-aos="fade-up"
            data-aos-duration="700"
          >
            <h1 className="text-center">
              Banyak Video Template yang Siap Pakai
            </h1>
            <p>
              Tersedia ribuan template video dengan tema Islamic, Minimalist,
              Elegant, Overlays Shadow, dan Water Color
            </p>
          </div>
        </div>
        <div className="row">
          <CardVideo url={url.url1} title={title.title1} />
          <CardVideo url={url.url2} title={title.title2} />
          <CardVideo url={url.url3} title={title.title3} />
        </div>
        <div
          className="row justify-content-center"
          data-aos="fade-up"
          data-aos-duration="700"
        >
          <div className="col-12 col-md-6 col-lg-3">
            <a href="#" target="_blank" className="btn btn-more">
              Lihat Semua Video Template
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TemplateVideo;
